/** Builds public Börse links with exactly one base-path prefix. */
export function getBoerseWebsiteUrl(path: string): string {
  return `https://www.fuw.ch/boerse${path.replace(/^\/boerse(?=\/|[?#]|$)/, "")}`
}
